// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"275f4949","656":"9952f57e","684":"4f75a031","710":"3ddd3aed","756":"86d14159","787":"b0f5c9d5"}[chunkId] + ".chunk.js";
};